import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const importModules = () => {
  const requireState = require.context("@/store/", true, /state.js$/);

  let store = {
    state: {},
    mutations: {},
    actions: {},
    modules: {}
  };

  requireState.keys().forEach(fileName => {
    const stateName = fileName.split("/")[1];
    const { state, getters, mutations, actions } = requireState(
      fileName
    ).default;

    store.state = {
      ...store.state,
      [stateName]: state
    };
    store.getters = {
      ...store.getters,
      ...getters
    };
    store.mutations = {
      ...store.mutations,
      ...mutations
    };
    store.actions = {
      ...store.actions,
      ...actions
    };
  });
  return store;
};

const store = importModules();

export default new Vuex.Store(store);
